import React from "react";
import './Confirm.scss'
import BaseButton from "../BaseButton/BaseButton";
import BottomSheet from "../BottomSheet/BottomSheet";
import closeCircle from '../../Assets/Icons/close_circle.svg'
import {useTranslation} from "react-i18next";

interface Props {
    visible: boolean,
    title: string,
    subTitle?: string,
    onOk: () => void,
    onCancel: () => void,
    icon?: string
}

const Confirm: React.FC<Props> = ({visible, title, subTitle, onOk, onCancel, icon = closeCircle}: Props) => {
    const {t} = useTranslation('common')
    return (
        <BottomSheet show={visible} close={onCancel}>
            <div className="confirm">
                <img className="confirm--img" src={icon} alt={t('alt.warningIcon')} />
                <p className="confirm--title">{title}</p>
                {subTitle && <p className="confirm--subTitle">{subTitle}</p>}
                <div className="confirm__actions">
                    <BaseButton onClick={onCancel} text={t('actions.no')} type="outline" className="confirm__actions--btn"/>
                    <BaseButton onClick={onOk} text={t('actions.yes')} type="filled" className="confirm__actions--btn"/>
                </div>
            </div>
        </BottomSheet>
    )
}

export default Confirm
